module.exports = __webpack_public_path__ + "img/Microsoft Exchange.2a71cf4c.svg";